import React from 'react'

export const CheckBox = props => {
    console.log(props);
    return (
      <div>
       <label><input key={props.id} onChange={props.handleInputChecked} type="checkbox" checked={props.isChecked} value={props.value} id={props.fieldId} disabled={props.isDisable} className="mgR10"/> {props.label}</label>      
      </div>
    )
}


export default CheckBox